import http from '../utils/request'

//请求数据

export const Login = (param) => {
  return http.post('/proxy', {"cmd": "login", "params": param})
}

export const PrivateLogin = (param) => {
  return http.post('/proxy', {"cmd": "private_login", "params": param})
}

export const FirstUpdatePrivate = (param) => {
  return http.post('/proxy', {"cmd": "first_update_private_password", "params": param})
}


export const UpdatePassword = (param) => {
  return http.post('/proxy', {"cmd": "update_password", "params": param})
}

export const UpdatePrivate = (param) => {
  return http.post('/proxy', {"cmd": "update_private_password", "params": param})
}

export const GetPorxyUserList = (param) => {
  return http.post('/proxy', {"cmd": "get_proxy_list", "params": param})
}

export const CreateProxy = (param) => {
  return http.post('/proxy', {"cmd": "create_proxy", "params": param})
}

export const GetUserList = (param) => {
  return http.post('/proxy', {"cmd": "get_user_list", "params": param})
}

export const CreateUser = (param) => {
  return http.post('/proxy', {"cmd": "create_user", "params": param})
}

export const GetUserInfo = (param) => {
  return http.post('/proxy', {"cmd": "get_user_info", "params": param})
}


export const GetProxyInfo = (param) => {
  return http.post('/proxy', {"cmd": "get_proxy_info", "params": param})
}


export const UpdateUserInfo = (param) => {
  return http.post('/proxy', {"cmd": "update_user_info", "params": param})
}

export const UpdateProxyInfo = (param) => {
  return http.post('/proxy', {"cmd": "update_proxy_info", "params": param})
}

export const BanUser = (param) => {
  return http.post('/proxy', {"cmd": "ban_user", "params": param})
}

export const PermissionUser = (param) => {
  return http.post('/proxy', {"cmd": "permit_user", "params": param})
}


export const BanProxy = (param) => {
  return http.post('/proxy', {"cmd": "ban_proxy", "params": param})
}

export const PermissionProxy = (param) => {
  return http.post('/proxy', {"cmd": "permit_proxy", "params": param})
}

export const SetUserScore = (param) => {
  return http.post('/proxy', {"cmd": "set_user_score", "params": param})
}

export const SetProxyScore = (param) => {
  return http.post('/proxy', {"cmd": "set_proxy_score", "params": param})
}

export const GetUserPaylog = (param) => {
  return http.post('/proxy', {"cmd": "get_user_paylog", "params": param})
}

export const GetProxyUserPaylog = (param) => {
  return http.post('/proxy', {"cmd": "get_proxy_user_paylog", "params": param})
}

export const GetUserDailyReport = (param) => {
  return http.post('/proxy', {"cmd": "get_user_daily_report", "params": param})
}

export const GetPlayersDailyReport = (param) => {
  return http.post('/proxy', {"cmd": "get_players_daily_report", "params": param})
}



export const GetCoins = (param) => {
  return http.post('/proxy', {"cmd": "get_coins", "params": param})
}


export const adminUpdatePwd = (param) => {
  return http.post('/proxy', {"cmd": "update_proxy_pwd", "params": param})
}

export const getPoolInfo = (param) => {
  return http.post('/proxy', {"cmd": "get_pool_info", "params": param})
}

export const generateUserIdBatch = (param) => {
  return http.post('/proxy', {"cmd": "generate_user_id_batch", "params": param})
}

export const submitRegularIds = (param) => {
  return http.post('/proxy', {"cmd": "submit_regular_ids", "params": param})
}

export const submitFancyIds = (param) => {
  return http.post('/proxy', {"cmd": "submit_fancy_ids", "params": param})
}

export const getUserId = (param) => {
  return http.post('/proxy', {"cmd": "get_user_id", "params": param})
}

export const getFancyUserId = (param) => {
  return http.post('/proxy', {"cmd": "get_fancy_user_id", "params": param})
}



// WEBPACK FOOTER //
// ./src/api/index.js